Vue.component('pagination', {

	props: ['last_page', 'current_page', 'num_items', 'num_total'],

	template: `
	<div class="paging d-flex flex-lg-row flex-column justify-content-between align-items-center">

		<div class='current-pagination'>
			Page <strong>{{ current_page }}</strong> of <strong>{{ last_page }}</strong> |
			Showing <strong>{{ num_items }}</strong> out of <strong>{{ num_total }}</strong> results.
		</div>

		<nav aria-label="Page navigation example" v-if="last_page > 1">
		  <ul class="paging justify-content-center p-0">

		    <li :class="{'paging-item': true, 'disabled' : current_page == 1}" @click.prevent="goToPage(current_page - 1)">
		    	<a class="paging-link" href="#"><i class="fa fa-angle-left"></i></a>
	    	</li>

	    	<li :class="{'paging-item': true, 'active' : current_page == 1}" @click.prevent="goToPage(1)">
		    	<a class="paging-link" href="#">1</a>
	    	</li>

	    	<li class="paging-item disabled" v-if="pages[0] > 2">
	    		<a class="paging-link">...</a>
	    	</li>

	    	<li v-for="page in pages" :class="{'paging-item': true, 'active': page == current_page}">
	    		<a href="#" class="paging-link" @click.prevent="goToPage(page)"">{{ page }}</a>
	    	</li>

	    	<li class="paging-item disabled" v-if="pages[pages.length - 1] < last_page - 1">
	    		<a class="paging-link">...</a>
	    	</li>

	    	<li :class="{'paging-item': true, 'active' : current_page == last_page}" @click.prevent="goToPage(last_page)">
		    	<a class="paging-link" href="#">{{ last_page }}</a>
	    	</li>


		    <li :class="{'paging-item': true, 'disabled' : current_page == last_page}" @click.prevent="goToPage(current_page + 1)">
		    	<a class="paging-link" href="#"><i class="fa fa-angle-right"></i></a>
	    	</li>
		  </ul>
		</nav>
	</div>
	`,

	methods: {
		goToPage(index) {
			if (index > 0 && index <= this.last_page) {
				this.$parent.$emit('change-page', index);
			}
		}
	},

	computed: {
		pages() {
			pages = []

			start = this.current_page - 1;

			if (start > 1) {

				for (i = start; i < this.current_page; i++) {
					pages.push(i)
				}
			}

			end = this.current_page + 1;

			if (this.current_page != 1 && this.current_page != this.last_page) {

				pages.push(this.current_page);

			}

			if (end < this.last_page) {

				for (i = this.current_page + 1; i <= end; i++) {
					pages.push(i);
				}

			}

			return pages;

		}

	}

});